import React from 'react';
import { Switch } from 'react-router-dom';
import RouterSuspense from '~/app/common/RouterSuspense';
import Detail from './Detail';
import { PERMISSION_GROUPS } from '~/accessControl/permissionGroups';
import PrivateRoute from '~/app/PrivateRoute';

export const TRAINING_ROUTES = {
    details: '/training/:id'
};

export type RouterComponent = React.FC

const Router: RouterComponent = () => (
    <RouterSuspense>
        <Switch>
            <PrivateRoute path={TRAINING_ROUTES.details} component={Detail} requiredPermissions={PERMISSION_GROUPS.training} />
        </Switch>
    </RouterSuspense>
);

export default Router;